export { ErrorBoundary } from './errorBoundary';
export type { ErrorBoundaryProps } from './errorBoundary';
